<template>
  <div class="text-center">
    <v-dialog
      v-model="dialog"
      :fullscreen="$vuetify.breakpoint.smAndDown"
      max-width="1000"
    >
      <v-card class="py-12">
        <v-card-title class="title">
          <v-spacer />
          <div class="text-center">
            <div>
              Coming soon!
            </div>
          </div>
          <v-spacer />
        </v-card-title>
        <v-card-text class="text-center">
          Sorry, this feature is not yet available. Stay tuned.
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn class="px-10" color="primary" rounded @click="close()">
            Close
          </v-btn>
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

export default {
  data() {
    return {
      dialog: false
    }
  },
  methods: {
    close() {
      this.dialog = false
    },
    show() {
      this.dialog = true
    },
  },
}
</script>